import React, { useState } from 'react';
import styled from 'styled-components/native';
import Button from '../../components/Button';
import WebViewModal from '../modals/WebViewModal';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;

const WebViewModalExampleScreen: React.FC = () => {
  const [showModal, setShowModal] = useState(true);
  return (
    <StyledContainer>
      <Button onPress={() => setShowModal(true)}>Show Modal</Button>
      {showModal && (
        <WebViewModal
          contentPadding
          visible={showModal}
          title='Whats An Impact Meter'
          html={`
          <html>
          <body>
          <h2>Italian Trulli</h2>
          <img src="https://www.w3schools.com/html/pic_trulli.jpg" alt="Italian Trullti" style="width:100%">
          <p>
          Lorem ipsum dolor sit amet consectetur. Ac fusce viverra leo magna fringilla faucibus felis cursus aliquam. Fringilla pretium vestibulum viverra facilisis velit. Viverra pellentesque sed dignissim vel in sed tristique. Semper imperdiet nulla ante in mauris duis.
          </p>
          <p>
          This paragraph
          contains a lot of lines
          in the source code,
          but the browser
          ignores it.
          </p>
          <p>
          This paragraph
          contains      a lot of spaces
          in the source     code,
          but the    browser
          ignores it.
          </p>
          <p>
          The number of lines in a paragraph depends on the size of the browser window. If you resize the browser window, the number of lines in this paragraph will change.
          </p>
          <div>
          <div style="position:relative;padding-top:56.25%;">
          <iframe frameborder="0" style="position:absolute;top:0;left:0;width:100%;height:100%;"src="https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"></iframe>
          </div>
          </div>
          <p>
          Video courtesy of
          <a href="https://www.bigbuckbunny.org/" target="_blank">Big Buck Bunny</a>.
          </body>
          </html>`}
          onClose={() => setShowModal(false)}
        />
      )}
    </StyledContainer>
  );
};

export default WebViewModalExampleScreen;
